import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=535b6926&scoped=true&"
import script from "./Faq.vue?vue&type=script&lang=ts&"
export * from "./Faq.vue?vue&type=script&lang=ts&"
import style0 from "./Faq.vue?vue&type=style&index=0&id=535b6926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b6926",
  null
  
)

export default component.exports